import React from 'react';
export function embedProps(elements, extraProps) {
  return React.Children.map(elements, function (element) {
    return /*#__PURE__*/React.cloneElement(element, extraProps);
  });
}